<div class="grid-header">
  <span  *ngIf="page === 'salesReport' && !showActions"></span>

  <div class="action-dropdown" *ngIf="showActions && page!=='Order-List'">
    <span
      [matMenuTriggerFor]="menu"
      (menuOpened)="menuOpened()"
      (menuClosed)="menuClosed()"
      style="display: flex"
    >
      <app-button [buttonSize]="'action'">
        Select Action &nbsp; &nbsp;
        <i
          class="fal"
          [ngClass]="{
            'fa-chevron-up': isMenuOpened,
            'fa-chevron-down': !isMenuOpened
          }"
        ></i>
      </app-button>
    </span>
    <mat-menu #menu="matMenu" class="mat-custom-dropdown">
      <button
        mat-menu-item
        class="action-dropdown-item"
        *ngFor="let action of allActions"
        (click)="action.callBackFn()"
        [disabled]="action.isDisabled"
      >
        <span [matTooltip]="action?.tooptipMessage" > {{action.title}}</span>
      </button>

      <div mat-menu-item class="action-dropdown-item" style="display: flex" 
      [matMenuTriggerFor]="updateInventoryBulk"
      *ngIf="((gridActionsService.selectedFilters | json) !== '{}' || gridActionsService.globalSearch) && 
      ( page === 'products'  || page === 'logistic')"> Update Inventory Bulk </div>
      
      <div
        mat-menu-item
        class="action-dropdown-item"
        *ngIf="
          ((gridActionsService.selectedFilters | json) !== '{}' || gridActionsService.globalSearch) && 
          (page === 'shipyard' || page === 'profitByProduct' || page === 'priceyard' || page === 'replenish' || page === 'items' || page==='profitByDate' || page==='profitBySkus' || page === 'orders' || page==='history' || page === 'sales-trends' || page === 'po-summary' || page === 'inventory-summary' || page === 'products' || page === 'Stock-holding'
           || page == 'shipment-list' || page == 'claim-Center')
        "
        style="display: flex"
        [matMenuTriggerFor]="exportMenu"
        [disabled]="userInfo.roleId === 2"
      >
        Export
      </div>
      <div mat-menu-item class="action-dropdown-item" style="display: flex" 
        [matMenuTriggerFor]="tagMenu"
        *ngIf="((gridActionsService.selectedFilters | json) !== '{}' || gridActionsService.globalSearch) && 
        (page === 'shipyard' || page === 'products' || page=='replenish' )"> Tags </div>
      <mat-menu #exportMenu="matMenu" class="mat-custom-dropdown">
        <button
          mat-menu-item
          class="action-dropdown-item"
          (click)="gridActionsService.exportSkus(page, false)"
        >
          Export all
        </button>
        <button
          mat-menu-item
          class="action-dropdown-item"
          (click)="gridActionsService.exportSkus(!isShowAccount ? 'profitByProduct' : page, true)"
        >
          Export current results
        </button>
      </mat-menu>

      <!-- <div mat-menu-item class="action-dropdown-item" style="display: flex" 
      [matMenuTriggerFor]="shipmentMenu"
      *ngIf="((gridActionsService.selectedFilters | json) !== '{}' || gridActionsService.globalSearch) && 
      (page === 'shipment-list')"> Export Shipment List</div>
      <mat-menu #shipmentMenu="matMenu" class="mat-custom-dropdown">
          <button mat-menu-item (click)="gridActionsService.exportShipment(true)">
            Export Shipments
          </button>
          <button mat-menu-item (click)="gridActionsService.exportShipment()">Export Shipments Detail</button>
      </mat-menu> -->

      <mat-menu #tagMenu="matMenu" class="mat-custom-dropdown">
        <button mat-menu-item class="action-dropdown-item" (click)="gridActionsService.tagsManagement(page,'Assign Tags')">
          Assign Tags
        </button>
        <button mat-menu-item class="action-dropdown-item" (click)="gridActionsService.tagsManagement(page,'Remove Tags')">
          Remove Tags
        </button>
      </mat-menu>

      <mat-menu #updateInventoryBulk="matMenu" class="mat-custom-dropdown">
        <button mat-menu-item class="action-dropdown-item" [matTooltip]="'Set the new total inventory quantity, replacing the existing quantity.'" (click)="gridActionsService.bulkOperations((headerService.useBinLocation ? 'AddItemToWLocationUseBinLocation' : 'AddItemToWLocation'),'Set',true)">
          Replace Stock 
        </button>
        <button mat-menu-item class="action-dropdown-item" [matTooltip]="'Add or subtract the entered quantity from the existing inventory total'" (click)="gridActionsService.bulkOperations((headerService.useBinLocation ? 'AddItemToWLocationUseBinLocation' : 'AddItemToWLocation'),'Update',true )">
          Adjust Stock
        </button>
      </mat-menu>
    </mat-menu>
  </div>

  <div class="grid-header_search" *ngIf="!hideSearch">
    <div class="grid-header_search-icon">
      <i
        class="fal"
        (click)="clearSearch()"
        [ngClass]="{
          'fa-search': !searchInput.value,
          'fa-times': searchInput.value
        }"
      ></i>
    </div>
    <input
      type="text"
      class="grid-header_input"
      placeholder="Search"
      [formControl]="searchInput"
    />
  </div>

  <!-- <div class="grid-header_sm-icon" (click)="showGridWrapperActions()">
    <span class="material-icons"> segment </span>
  </div> -->
  <div class="grid-header_actions" [ngClass]="{ show: isShow }">
    <div
      class="header-button"
      *ngIf="page === 'purchasing' || page === 'replenish' || page == 'purchase-by-sku'"
      (click)="openFiltersDialog($event)"
    >
      <div class="header-button_left">
        <span class="header-button_name"
          >Filters</span
        >
        <div class="header-button_filter-text" *ngIf="filterText">
          {{ filterText }}
          <i class="fas fa-minus-circle" (click)="filterReset($event)"></i>
        </div>
      </div>
      <div class="setting_icon">
        <i class="fal fa-filter"></i>
      </div>
    </div>
    <div class="header-button" *ngIf="page === 'replenish'" (click)="openFilterPoId($event)">
      <div class="header-button_left">
        <span class="header-button_name">Filter PO ID</span>
        <div class="header-button_filter-text" *ngIf="filterPoId">
          {{ filterPoId }}
          <i class="fas fa-minus-circle" (click)="filterPoIdReset($event)"></i>
        </div>
      </div>
      <div class="header-button_icon">
        <i class="fal fa-filter"></i>
      </div>      
  </div>

    <div
      class="header-button"
      *ngIf="page === 'replenish' || page == 'purchasing' || page == 'purchase-by-sku'"
      (click)="openSettingDialog($event)"
    >

      <span class="header-button_name"
        >Setting</span
      >
      <div class="header-button_icon">
        <i class="fal fa-cog"></i>
      </div>
    </div>

    <div class="date-button" *ngIf="page === 'profitByProduct'">
      <div class="date-button_label">View By</div>
      <select class="date-button_button" [formControl]="groupByFilter" (change)="onChange($event)">
              <option [value]="'Date'">Date</option>
               <option [value]="'Account'">Account</option>
              
      </select>
      <div class="date-button_icon">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>

    <div class="date-button" *ngIf="page === 'profitBySkus'">
      <div class="date-button_label">Group By</div>
      <select class="date-button_button" [formControl]="groupProfitBySkuFilter" (change)="onProfitBySkuChange($event)">
               <option [value]="'Sku'">Sku</option>
               <option [value]="'Asin'">Asin</option>
               <option [value]="'Product'">Product</option>
      </select>
      <div class="date-button_icon">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>

    <div class="date-button" *ngIf="page === 'Itemized Data'">
      <div class="date-button_label">Group By</div>
      <select class="date-button_button" [formControl]="gridTypeInput">
        <option value="date">Date</option>
        <option value="sku">SKU</option>
      </select>
      <div class="date-button_icon">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>

   

    <div class="date-button" *ngIf="page === 'sales-trends'">
      <div class="date-button_label">Group By</div>
      <select class="date-button_button" [formControl]="salesGridInput">
        <option value="orders">Default</option>
        <option value="columns">Date Range</option>
        <option value="qty">Columns</option>
      </select>
      <div class="date-button_icon">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>

    <div class="date-button" *ngIf="page === 'sales-trends' && showDefaultColumn">
      <div class="date-button_label">Default Columns</div>
      <select class="date-button_button" [formControl]="defaultGridInput">
        <option value="Sales">Sales Revenue</option>
        <option value="QtySold">Qty Sold</option>
        <option value="Returns">Returns</option>
        <option value="Profit">Profit</option>
      </select>
      <div class="date-button_icon">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>

    <div class="date-button" *ngIf="(page === 'profitByDate' || page === 'profitBySkus' || page === 'sales-trends' || page==='orders' || page === 'Order-List') && isShowAccount">
      <div class="date-button_label">Account</div>
      <select class="date-button_button" [formControl]="accountFilter">
        <option value="all">All</option>
        <option [value]="item.name" *ngFor="let item of allAccounts">{{item.name}}</option>
      </select>
      <div class="date-button_icon">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>
 <ng-container *ngIf="page === 'P&L'">
    <div class="date-button" >
      <div class="date-button_label">View By</div>
      <select class="date-button_button" [formControl]="plFilter" (change)="plFilterChange($event)">
        <option [value]="item" *ngFor="let item of allPl">{{item}}</option>
      </select>
      <div class="date-button_icon">
        <i class="fal fa-chevron-down"></i>
      </div>
    </div>
    <div class="date-button" >
      <div class="date-button_label">Date</div>
      <mat-form-field appearance="fill" class="custom-date-range-input">
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Start date" #dateRangeStart>
            <input matEndDate formControlName="end" placeholder="End date" #dateRangeEnd (dateChange)="getDateRange(dateRangeStart,dateRangeEnd)"
           >
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <div class="date-button_icon date-button_arrowIcon">
      <i class="fal fa-chevron-down"></i>
    </div>
    </div>
  </ng-container>  

    <!-- <div *ngIf="page === 'salesReport'">
      <div class="page-navigator">
        <div class="page-navigator_button" matTooltip="Table View" [routerLink]="['/analytics/table']" routerLinkActive="page-navigator_button--selected">
          <i class="fas fa-table"></i>
        </div>
        <div class="page-navigator_button" matTooltip="Pie Chart" [routerLink]="['/analytics/line-chart']" routerLinkActive="page-navigator_button--selected">
          <i class="fas fa-chart-bar"></i>
        </div>
        <div class="page-navigator_button" matTooltip="Bar Chart" [routerLink]="['/analytics/pie-chart']" routerLinkActive="page-navigator_button--selected">
          <i class="fas fa-chart-pie"></i>
        </div>
      
      
      </div>
    </div> -->
    <app-date-component-renderer [isGraphDataChange]="false" [currentDateFilter]="defaultDateFilter" [isOrderFilter]="true" (dateFilterOutput)="dateFilterChange($event)" [page]="page"

    *ngIf="page === 'orders' || page === 'salesReport' || page === 'sales-trends' || page === 'history' || page==='profitByDate' || page === 'profitBySkus' || page ==='Order-List' || page === 'profitByProduct' || page === 'analytics' || page == 'po-summary' ||(page === 'KPIs-sales' && showDateFilter) ||  page == 'feeMonitor' || page === 'priceyard-history'">
    </app-date-component-renderer>

    <div class="date-button" *ngIf="page === 'KPIs-sales' && router.url == '/analytics/overstocked'">
      <div class="date-button_label">Date</div>
      <select class="date-button_button_order" [(ngModel)]="datePickerLabel" (change)="onDateChange($event)">
        <option value="Last 90 Days">Over 90 days</option>
        <option value="Last 180 Days" selected>Over 180 days</option>
        <option value="Last 365 Days" selected>Over 365 days</option>
       </select>
       <div class="date-button_order_icon">
        <i class="fal fa-chevron-down"></i>
      </div> 
    </div>

    <div class="date-button" *ngIf="page === 'inventory-summary'">
      <div class="date-button_label">Date</div>
      <div class="date-button_picker" (click)="dp.open()">
          <input class="date-button_button_order" matInput [matDatepicker]="dp" readonly  [formControl]="date">
          <div class="date-button_order_icon">
            <i class="fal fa-chevron-down"></i>
          </div> 
          <mat-datepicker #dp
                          startView="year"
                          (yearSelected)="chosenYearHandler($event)"
                          (monthSelected)="chosenMonthHandler($event, dp)"
                          panelClass="example-month-picker">
          </mat-datepicker>
      </div>
    </div>

    <app-button
      *ngIf="page == 'priceyard-history' || page=='history'"
      [buttonSize]="'action'"
      [buttonStyle]="'text'"
      (click)="gridActionsService.refresh()"
      >Refresh</app-button
    >

    <app-button
      *ngIf="page == 'products'"
      [buttonSize]="'action'"
      (click)="gridActionsService.addItem()"
      >Add New Product</app-button
    >

    <app-button
      *ngIf="page == 'vendors'"
      [buttonSize]="'action'"
      (click)="gridActionsService.addVendor()"
      >Add Vendor</app-button
    >
    <app-button *ngIf="page == 'modelPanel'" [buttonSize]="'action'" (click)="gridActionsService.addSkuToModel()">Add Sku</app-button>
    <div *ngIf="page === 'cost-deatils'">
      <div class="sidebar-toggle">
        <span class="sidebar-toggle_label">Missing COGS</span>
        <div class="toggle-switch">
          <input type="checkbox" id="cogs" [checked]="missingCogs" (change)="toggleCogs()"/>
          <label for="cogs">Toggle</label>
        </div>
      </div>
    </div>

    <div *ngIf="page === 'logistic' && headerService.useBinLocation" class="d-flex gap-2">
      <div class="date-button">
        <select name="" id="" [formControl]="warehouse"
          class="input-container_input input-container_input--select date-button_button"
          (change)="onWarehouseChange($event)">
          <option value="all">All</option>
          <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
            {{ warehouse.id }}
          </option>
        </select>
      </div>
      <app-button [buttonSize]="'action'"
    (click)="gridActionsService.addLocation()"
    >Add New</app-button>
    </div>

    <div *ngIf="hasSidebar">
      <div class="sidebar-toggle">
        <span class="sidebar-toggle_label">Show Sidebar</span>

        <div class="toggle-switch">
          <input type="checkbox" id="switch" [(ngModel)]="openToolPanel" />
          <label for="switch">Toggle</label>
        </div>
      </div>
    </div>

    <div (click)="openColumnChooser($event)" *ngIf="(page !=='ship-batch-details' && page !== 'P&L') && !isHideColumnChooser">
      <img src="../../../assets/images/coulumn-open-icon.svg" alt="" />
    </div>
  </div>
</div>
